import React, { useCallback, useEffect, useReducer, useState } from "react"
import {
    excluirNotificacao,
    obterNotificacoesAgendadas,
    obterNotificacoesEnviadas,
} from "../../../services/notificacoesFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { VerNotificacoesFornecedorInicial } from "../models/verNotificacoesFornecedorModel"
import { VerNotificacoesFornecedorActionsTypes } from "./verNotificacoesFornecedorActions"
import { VerNotificacoesFornecedorContext } from "./VerNotificacoesFornecedorContext"
import { verNotificacoesFornecedorReducer } from "./verNotificacoesFornecedorReducer"

export function VerNotificacoesFornecedorContextProvider({
    children,
}: {
    children: React.ReactNode
}) {
    const [dados, dispatch] = useReducer(
        verNotificacoesFornecedorReducer,
        VerNotificacoesFornecedorInicial
    )
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const pesquisar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const res = await obterNotificacoesEnviadas(
                autorizacao,
                dados.filtro.dataInicio,
                dados.filtro.dataFim,
                dados.filtro.titulo
            )
            if ("retornoErro" in res) {
                setErroCarregamento(res.mensagem || "Erro ao carregar notificações enviadas")
            } else {
                setErroCarregamento(null)
                dispatch({
                    type: VerNotificacoesFornecedorActionsTypes.CARREGAR_ENVIADAS,
                    payload: res,
                })
            }
        } catch {
            setErroCarregamento("Erro ao carregar notificações enviadas")
        } finally {
            setLoading(false)
        }
    }, [dados.filtro, setLoading])

    const excluir = useCallback(
        async (id: number) => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return
            try {
                setLoading(true)
                const res = await excluirNotificacao(autorizacao, id)
                if (res && "retornoErro" in res) {
                    setErroCarregamento(res.mensagem || "Erro ao excluir notificação")
                } else {
                    dispatch({
                        type: VerNotificacoesFornecedorActionsTypes.REMOVER_AGENDADA,
                        payload: { id },
                    })
                }
            } catch {
                setErroCarregamento("Erro ao excluir notificação")
            } finally {
                setLoading(false)
            }
        },
        [setLoading]
    )

    useEffect(() => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return

        const carregarAgendadas = async () => {
            try {
                setLoading(true)
                const res = await obterNotificacoesAgendadas(autorizacao)
                if ("retornoErro" in res) {
                    setErroCarregamento(res.mensagem || "Erro ao carregar notificações agendadas")
                } else {
                    dispatch({
                        type: VerNotificacoesFornecedorActionsTypes.CARREGAR_AGENDADAS,
                        payload: res,
                    })
                }
            } catch {
                setErroCarregamento("Erro ao carregar notificações agendadas")
            } finally {
                setLoading(false)
            }
        }

        carregarAgendadas()
        pesquisar()
    }, [])

    return (
        <VerNotificacoesFornecedorContext.Provider
            value={{ dados, dispatch, erroCarregamento, pesquisar, excluir }}
        >
            <Loading />
            {children}
        </VerNotificacoesFornecedorContext.Provider>
    )
}
